import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { GET_INVOICE } from '@/store/models/work/enterprise/invoices/outgoing';
import { Invoice, Product } from '@/types/work/invoice';

const PATH = 'work/enterprises/invoices/outgoing/products/';

export const PRODUCTS_REQUEST = PATH + 'request';
export const STORE_REQUEST = PATH + 'storeRequest';
export const GET_PRODUCTS = PATH + 'getProducts';

const state = {
  status: null,
  products: [],
  product: {}
};

const getters = {
  getProducts: (state:any):Array<Product> => state.products
};

const actions = {
  request: ({ commit, rootGetters }:any, id:number) => {
    let enterprise:Enterprise = rootGetters[GET_ENTERPRISE];
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise.id}/invoices/outgoing/${id}/products` })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  storeRequest: ({ commit, rootGetters }:any, data:Product) => {
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      let invoice: Invoice = rootGetters[GET_INVOICE];
      // TODO: make store product
    });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<Product>) => {
    state.status = true;
    state.products = resp;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
